module.exports = __webpack_public_path__ + "fonts/Lato-400-latin-ext5.4bde07f.woff2";